import { Routes, Route, Navigate } from 'react-router-dom';
import {Helmet} from "react-helmet";

import { useAuth } from './AuthContext';
import Navbar from './components/Navbar';
import SideNav from './components/SideNav';
import Login from './Login';
import Admin from './Admin';
import DocumentValidation from './DocumentValidation';
import MatchToDocument from './MatchToDocument';
import PassivePad from './PassivePadSystems';
import { Grid2 } from '@mui/material';
import Home from './Home';
import DatasetSubmission from './DatasetSubmission';
import UserAdmin from './UserAdmin';
import MatchingSystems from './MatchingSystems';
import { useState } from 'react';
import toastOptions from './components/toastOptions';

const App = () => {
  const { isLoggedIn, isAdmin, isInternal, user } = useAuth();
  const staging = "https://staging-mdtf.org:3001";
  const dev1 = "https://upload-portal-mdtf.org:3001";

  const [submitOverlay, setSubmitOverlay] = useState(false);

  const handleSubmitOverlay = (data) => {
    setSubmitOverlay(data);
  }

  return (
    <div>
      {process.env.REACT_APP_BACKEND_SERVER_HOST == staging && <TitleChange env="Staging" /> }
      {process.env.REACT_APP_BACKEND_SERVER_HOST == dev1 && <TitleChange env="Dev1" /> }
        {!isLoggedIn ? (
          <Login />
        ) : (
        <div>  
          <Navbar user={user} isSubmit={submitOverlay} />
          <Grid2 container spacing={2} sx={{height: '90vh'}}>
            <Grid2 item className='app-grid1'>
              <SideNav isAdmin={isAdmin} isInternal={isInternal} user={user} isSubmit={submitOverlay} />
            </Grid2>
            <Grid2 size={{xs: 12, sm: "grow"}}>
              <Routes>
                <Route
                  path="/"
                  element={
                    isAdmin || isInternal ? (
                      <Grid2 size="grow">
                        <Admin isInternal={isInternal} toastOptions={toastOptions} />
                      </Grid2> 
                    ) : (
                      <Grid2 size="grow">
                        <Home user={user} toastOptions={toastOptions} />
                      </Grid2>)}
                />
                <Route path="/home" element={isLoggedIn ? <Home user={user} toastOptions={toastOptions} /> : <Navigate replace to="/login" />} />
                <Route path="/dataset-submission" element={isLoggedIn ? <DatasetSubmission isSubmit={handleSubmitOverlay} user={user} isInternal={isInternal} isAdmin={isAdmin}/> : <Navigate replace to="/login" />} />
                <Route path="/document-validation" element={isLoggedIn ? <DocumentValidation isSubmit={handleSubmitOverlay} isAdmin={isAdmin} isInternal={isInternal} user={user} /> : <Navigate replace to="/login" />} />
                <Route path="/match-to-document" element={isLoggedIn ? <MatchToDocument isSubmit={handleSubmitOverlay} isAdmin={isAdmin} isInternal={isInternal} user={user} /> : <Navigate replace to="/login" />} />
                <Route path="/matching-systems" element={isLoggedIn ? <MatchingSystems isSubmit={handleSubmitOverlay} isAdmin={isAdmin} isInternal={isInternal} user={user} /> : <Navigate replace to="/login" />} />
                <Route path="/passive-pad-systems" element={isLoggedIn ? <PassivePad isSubmit={handleSubmitOverlay} isAdmin={isAdmin} isInternal={isInternal} user={user} /> : <Navigate replace to="/login" />} />
                <Route path="/admin" element={isAdmin || isInternal ? <Admin isInternal={isInternal} toastOptions={toastOptions} /> : <Navigate replace to="/login" />} />
                <Route path="/user-admin" element={isAdmin || isInternal ? <UserAdmin isAdmin={isAdmin} /> : <Navigate replace to="/login" />} />
              </Routes>
            </Grid2>
          </Grid2>
        </div>
        )}
    </div>
  );
}

const TitleChange = ({env}) => {
  return(
    <div>
      <Helmet>
        <meta charSet='utf-8'/>
        <title>MyConsole - MdTF {env}</title>
        <link rel="canonical" href="%PUBLIC_URL%/manifest.json" />
      </Helmet>
    </div>
  )
}

export default App;
